import { getToday } from './getToday';

export const getTodayName = (fromRef, toRef) => {
	const from = fromRef?.current?.value || getToday();
	const to = toRef?.current?.value || getToday();

	return `${from}_${to}`;
};
